import React from "react";
import celebal from "../assets/celebal.png";
import infosys from "../assets/infosys.png";
import jpmorgan from "../assets/jpmorgan.jpg"
const Experience = () => {
  return (
    <div className="mx-10 md:mx-72 text-center md:text-start mt-40">
      <div className="flex items-center flex-col">
        <div className="text-[#AD9ED9] font-semibold text-lg">Experience</div>
        <div className="text-3xl md:text-5xl font-semibold mt-2">
          My Professional Journey
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between mt-32">
        <div className="h-20 w-20 mb-5 md:mb-0 md:h-40 md:w-40">
          <img src={jpmorgan} alt="" />
        </div>
        <div className="w-4/5">
          <div className="text-2xl font-semibold">
            Software Development Engineer II
          </div>
          <div className=" text-[#AD9ED9]">
            JPMorgan Chase & Co., Mumbai, IN
          </div>
          <div className="mt-3">
            I specialize in architecting and scaling full-stack applications
            enriched with AI-driven capabilities. My work involves seamlessly
            integrating large language models (LLMs), vector embeddings, and
            automation workflows into modern web platforms. On the frontend, I
            focus on building intuitive and responsive user interfaces using
            cutting-edge frameworks to deliver cohesive AI-powered experiences.
            Beyond application development, I’ve led innovative initiatives at
            the intersection of AI and engineering—working extensively on model
            context protocols and leveraging a diverse suite of tools including
            Cline, AI agents, copilots, and other advanced systems. These
            efforts have enabled intelligent automation and next-generation
            product experiences across a variety of domains.
          </div>
          <div className="flex justify-between mt-2">
            <div className="text-sm text-gray-500">Jan 2025 - Present</div>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between mt-32">
        <div className="h-20 w-20 mb-5 md:mb-0 md:h-40 md:w-40">
          <img src={infosys} alt="" />
        </div>
        <div className="w-4/5">
          <div className="text-2xl font-semibold">Specialist Programmer</div>
          <div className=" text-[#AD9ED9]">Infosys, Pune, IN</div>
          <div className="mt-3">
            As a Specialist Programmer at Infosys, I led the migration of a
            large-scale project from React.js to Next.js, incorporating Static
            Site Generation (SSG) and Server-Side Rendering (SSR) to achieve a
            40% increase in application performance and reduce page load times.
            I managed a team of 4 developers to implement advanced SEO
            strategies, resulting in a 30% increase in organic traffic. I also
            developed a custom analytics solution similar to Google Analytics,
            boosting click-through rates by 25% and user engagement by 15%.
            Additionally, I enhanced code quality through rigorous reviews and
            best practices, leading to a 20% reduction in bug rates and improved
            stability.
          </div>
          <div className="flex justify-between mt-2">
            <div className="text-sm text-gray-500">Dec 2023 - Jan 2025</div>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between mt-32">
        <div className="h-20 w-20 mb-5 md:mb-0 md:h-40 md:w-40">
          <img src={celebal} alt="" />
        </div>
        <div className="w-4/5">
          <div className="text-2xl font-semibold">
            Associate Full Stack Developer
          </div>
          <div className="text-[#AD9ED9]">Celebal Technologies, Pune, IN</div>
          <div className="mt-3">
            In my role as an Associate Full Stack Developer at Celebal
            Technologies, I architected and optimized AI-driven solutions using
            Next.js, React.js, Node.js, and Azure, significantly enhancing
            system performance and scalability. I developed and implemented
            CI/CD pipelines with Azure DevOps, ensuring faster and more reliable
            releases. Additionally, I optimized back-end systems with scalable
            microservices architectures, leading to a 25% improvement in
            performance and reliability.
          </div>
          <div className="flex justify-between mt-2">
            <div className="text-sm text-gray-500">Nov 2021 - Dec 2023</div>
          </div>
        </div>
      </div>

      {/* Add more experience items as needed */}
    </div>
  );
};

export default Experience;
